import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_USERS,
  GET_USER_PROFILE,
  ADD_NEW_USER,
  DELETE_USER,
  UPDATE_USER,
  GET_USER_BY_ID
} from "./actionTypes"

import {
  getUsersSuccess,
  getUsersFail,
  getUserProfileSuccess,
  getUserProfileFail,
  addUserFail,
  addUserSuccess,
  updateUserSuccess,
  updateUserFail,
  deleteUserSuccess,
  deleteUserFail,
  toggleUsersLoading,
  getUserByIdSuccess,
  getUserByIdFail
} from "./actions"

import {
  getUsers,
  getUserProfile,
  addNewUser,
  updateUser,
  deleteUser,
  getUserById
} from "../../helpers/users_helper"

function* fetchUsers({ payload }) {
  console.log("fetchUsers", payload);

  yield put(toggleUsersLoading())
  try {
    const response = yield call(getUsers, payload)
    yield put(getUsersSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
  yield put(toggleUsersLoading())
}

function* fetchUserProfile() {
  try {
    const response = yield call(getUserProfile)
    yield put(getUserProfileSuccess(response))
  } catch (error) {
    yield put(getUserProfileFail(error))
  }
}

function* onUpdateUser({ payload: user }) {
  try {
    const response = yield call(updateUser, user)
    yield put(updateUserSuccess(response))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onDeleteUser({ payload: user }) {
  try {
    const response = yield call(deleteUser, user)
    yield put(deleteUserSuccess(response))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onAddNewUser({ payload: user }) {

  try {
    const response = yield call(addNewUser, user)

    yield put(addUserSuccess(response))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

function* fetchUserById({ payload }) {
  yield put(toggleUsersLoading())
  try {
    const response = yield call(getUserById, payload)
    yield put(getUserByIdSuccess(response))
  } catch (error) {
    console.log('error', error);
    yield put(getUserByIdFail(error))
  }

  yield put(toggleUsersLoading())
}

function* usersSaga() {
  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(GET_USER_PROFILE, fetchUserProfile)
  yield takeEvery(ADD_NEW_USER, onAddNewUser)
  yield takeEvery(UPDATE_USER, onUpdateUser)
  yield takeEvery(DELETE_USER, onDeleteUser)
  yield takeEvery(GET_USER_BY_ID, fetchUserById)
}

export default usersSaga;
